import { render } from "./CustomSelectOneDocumentType.vue?vue&type=template&id=39ff418e"
import script from "./CustomSelectOneDocumentType.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneDocumentType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__